var map = {
	"./about-us-banner.webp": 216,
	"./anniversary-banner-bm.webp": 1695,
	"./anniversary-banner-cn.webp": 1696,
	"./anniversary-banner-id.webp": 1697,
	"./anniversary-banner.webp": 1698,
	"./banner-01.jpg": 1699,
	"./banner-slot.jpg": 1700,
	"./bet-and-earn-banner-cn.webp": 1701,
	"./bet-and-earn-banner-indon.webp": 1702,
	"./bet-and-earn-banner-ms.webp": 1703,
	"./bet-and-earn-banner.webp": 1704,
	"./check-in-banner-cn.webp": 1705,
	"./check-in-banner-id.webp": 1706,
	"./check-in-banner-ms.webp": 1707,
	"./check-in-banner.webp": 1708,
	"./cny_2024-bm.webp": 1709,
	"./cny_2024-cn.webp": 1710,
	"./cny_2024.webp": 1711,
	"./epl-banner-cn.jpg": 1712,
	"./epl-banner-cn.webp": 1713,
	"./epl-banner-indo.jpg": 1714,
	"./epl-banner-indo.webp": 1715,
	"./epl-banner-ms.jpg": 1716,
	"./epl-banner-ms.webp": 1717,
	"./epl-banner.jpg": 1718,
	"./epl-banner.webp": 1719,
	"./games-banner-bm.webp": 1720,
	"./games-banner-cn.webp": 1721,
	"./games-banner-id.webp": 1722,
	"./games-banner.webp": 1723,
	"./lb-m-banner-cn.webp": 1724,
	"./lb-m-banner.webp": 1725,
	"./leaderboard-banner-cn.webp": 1726,
	"./leaderboard-banner.webp": 1727,
	"./lottery-banner.webp": 1728,
	"./lottery-banners-bm.webp": 1729,
	"./lottery-banners-cn.webp": 1730,
	"./lottery-banners-id.webp": 1731,
	"./lottery-banners.webp": 1732,
	"./lucky-spin-banner-cn.webp": 1733,
	"./lucky-spin-banner-ms.webp": 1734,
	"./lucky-spin-banner-vn.webp": 1735,
	"./lucky-spin-banner.webp": 1736,
	"./p2p-banner.webp": 1737,
	"./p2p-banners-bm.webp": 1738,
	"./p2p-banners-cn.webp": 1739,
	"./p2p-banners-id.webp": 1740,
	"./p2p-banners.webp": 1741,
	"./premier-league-banner-cn.webp": 1742,
	"./premier-league-banner.webp": 1743,
	"./promos-banner-cn.webp": 1744,
	"./promos-banner-indon.webp": 1745,
	"./promos-banner-ms.webp": 1746,
	"./promos-banner.webp": 1747,
	"./promos-detail-banner.jpg": 1748,
	"./side-bar-banner.jpg": 1749,
	"./uefa24-prediction-bm.webp": 1750,
	"./uefa24-prediction-cn.webp": 1751,
	"./uefa24-prediction-id.webp": 1752,
	"./uefa24-prediction.webp": 1753,
	"./vip-banner-cn.webp": 1754,
	"./vip-banner-id.webp": 1755,
	"./vip-banner-ms.webp": 1756,
	"./vip-banner-vn.webp": 1757,
	"./vip-banner.webp": 1758,
	"./winner-leaderboard-banner-cn.webp": 1759,
	"./winner-leaderboard-banner.webp": 1760,
	"./world-cup-banner-cn.webp": 1761,
	"./world-cup-banner.webp": 1762,
	"./world-cup-two-banner-cn.webp": 1763,
	"./world-cup-two-banner.webp": 1764,
	"./xmas_2023-bm.jpg": 1765,
	"./xmas_2023-cn.jpg": 1766,
	"./xmas_2023-id.jpg": 1767,
	"./xmas_2023.jpg": 1768,
	"./xmas_2024-bm.webp": 1769,
	"./xmas_2024-cn.webp": 1770,
	"./xmas_2024.webp": 1771
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;